import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "option-icon" }
const _hoisted_2 = ["id", "value", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "tags"
}
const _hoisted_5 = { class: "link" }
const _hoisted_6 = { class: "modal details" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "mobile-footer",
  hidden: ""
}
const _hoisted_11 = { class: "center-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        id: 'transfer' + _ctx.id,
        type: "radio",
        name: "transferOptions",
        value: _ctx.transfer.hotelTransferKey,
        checked: _ctx.selectedTransferKey === _ctx.transfer.hotelTransferKey,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateTransfer(_ctx.transfer)))
      }, null, 40, _hoisted_2),
      _createElementVNode("label", {
        for: 'transfer' + _ctx.id
      }, [
        _createElementVNode("span", {
          class: "label-content",
          style: _normalizeStyle(_ctx.optionStyle)
        }, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.transfer.name), 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.transfer.shortDescription), 1)
          ])
        ], 4),
        (_ctx.transfer.additionalPrice)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "+ " + _toDisplayString(_ctx.transfer.additionalPrice.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(_ctx.transfer.currency), 1))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal($event)))
          }, _toDisplayString(_ctx.pageTexts['hotelPageTransferStepLabelSeeDetails']), 1)
        ])
      ], 8, _hoisted_3)
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModal) = $event)),
      close: _ctx.closeModal,
      onBeforeEnter: _ctx.fixBody,
      onAfterLeave: _ctx.unfixBody
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("header", null, [
            _createElementVNode("button", {
              class: "close-btn",
              title: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, null, 8, _hoisted_7),
            _createElementVNode("h2", null, _toDisplayString(_ctx.transfer.name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "rte",
              innerHTML: _ctx.transfer.description
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonBack']), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "close", "onBeforeEnter", "onAfterLeave"])
  ], 64))
}